import { render, staticRenderFns } from "./PaySources.vue?vue&type=template&id=2b4b26df"
import script from "./PaySources.vue?vue&type=script&lang=js"
export * from "./PaySources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports